import React from 'react';

import Createaccountform from '../../Components/Form/Createaccountform';
import "./Createaccount.css";


function Createaccount(){
  return (
    <div className='createaccount'>
        <div>
            <Createaccountform/>
        </div>
    </div>
  );
}

export default Createaccount;
